import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({ baseURL: process.env.REACT_APP_BASE_URL });
api.interceptors.request.use((c) => {
  const t = getToken();
  if (t) c.headers["Authorization"] = `Bearer ${t}`;
  return c;
});

// ── Legacy (kept for backward compat) ──────────────────────────
export const fetchAllPayments        = (p = {}) => api.get("/admin/payments", { params: p });
export const fetchPaymentsByUser     = (userId)  => api.get(`/admin/payments/user/${userId}`);

// ── Unified summary ────────────────────────────────────────────
export const fetchUnifiedSummary     = ()        => api.get("/admin/payments/unified-summary");

// ── Unified paginated list (All tab) ──────────────────────────
export const fetchUnifiedPayments    = (p = {})  => api.get("/admin/payments/unified", { params: p });

// ── Subscriptions tab ─────────────────────────────────────────
export const fetchSubscriptionPayments = (p = {}) => api.get("/admin/payments", { params: p });
export const updateSubscriptionPayment = (id, body) => api.patch(`/admin/payments/subscription/${id}`, body);
export const deleteSubscriptionPayment = (id)       => api.delete(`/admin/payments/subscription/${id}`);

// ── Events tab ────────────────────────────────────────────────
export const deleteEventPayment      = (id)      => api.delete(`/admin/payments/event/${id}`);

// ── Courses tab ───────────────────────────────────────────────
export const fetchCoursePaymentsAdmin = (p = {}) => api.get("/admin/courses/payments", { params: p });
export const updateCoursePaymentAdmin = (enrollmentId, body) => api.patch(`/admin/courses/payments/${enrollmentId}`, body);
export const deleteCoursePaymentAdmin = (enrollmentId)       => api.delete(`/admin/courses/payments/${enrollmentId}`);
